import React from "react";
import { ReactComponent as TickIcon } from "assets/img/svg/TickIcon.svg"; // same icon used in system
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { getFormattedAmount } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const tickStyle = {
  background: "#05945B",
  borderRadius: "50%",
  height: "30px",
  width: "30px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const DepositSuccessContent = ({
  details = {}, // { totalReceipts, totalAmount, depositSlipId }
  onClose = () => {}, // Go to dashboard / close modal
  onView = () => {}, // View deposit slip
  isCheque = false,
}) => {
  const {
    totalReceipts = "--",
    totalAmount = 0,
    depositSlipId = "--",
  } = details;

  const formatCurrency = (amt) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 2,
    }).format(amt || 0);

  return (
    <div style={{ minWidth: "400px" }}>
      {/* Header */}
      <div className="d-flex align-items-center gap-3 mb-4">
        <div style={tickStyle}>
          <TickIcon />
        </div>
        {/* <div className="extra-large-bold color-black">
          Cash deposit send for approval
        </div> */}
      </div>

      {/* Fields */}
      <div className="mb-4 d-flex  justify-content-between">
        <div className="regular-bold color-black mb-1">
          Count of total {isCheque ? "cheques" : "receipts"}
        </div>
        <div className="label-color regular-text semi-bold  text-dark">
          {totalReceipts}
        </div>
      </div>

      <div className="mb-4 d-flex  justify-content-between">
        <div className="regular-bold color-black mb-1">
          Total amount to be deposited
        </div>
        <div className="label-color regular-text semi-bold  text-dark">
          {getFormattedAmount(totalAmount)}
        </div>
      </div>

      {!isCheque && (
        <div className="mb-4 d-flex  justify-content-between">
          <div className="regular-bold color-black mb-1">
            Deposition Slip no.
          </div>
          <div className="label-color regular-text semi-bold  text-dark">
            {depositSlipId}
          </div>
        </div>
      )}
      <div className="d-flex gap-3">
        <AButton variant="outline" className="w-50" size="sm" onClick={onClose}>
          Close
        </AButton>
        <AButton variant="outline" className="w-50" size="sm" onClick={onView}>
          View
        </AButton>
      </div>
    </div>
  );
};

export default DepositSuccessContent;
